module.exports = require('./internal/FixedDataTableRoot');



//////////////////
// WEBPACK FOOTER
// ./~/fixed-data-table/main.js
// module id = 1031
// module chunks = 2